import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { KioskType } from '../../../context/types';
import { useKioskManager } from '../../../hooks/useKioskManager';
import ShareDirectionsToMobileModal from '../../shareDirectionsToMobileModal/ShareDirectionsToMobileModal';
import ButtonStyled from '../button/Button';
import Icon from '../icon/Icon';
import { IconType } from '../icon/types';
import styles from './KioskDirectionsHeader.module.scss';

interface KioskDirectionsHeaderProps {
  destination: string;
  onClose?: () => void;
}

export const KioskDirectionsHeader: React.FC<KioskDirectionsHeaderProps> = ({
  destination,
  onClose,
}) => {
  const { t } = useTranslation('common');
  const backButtonLabel = t('campusNavigation.share.backButton');
  const { kiosk, kioskMode } = useKioskManager();

  const [
    isShareDirectionsToPhoneModalOpen,
    setIsShareDirectionsToPhoneModalOpen,
  ] = useState<boolean>(false);

  return (
    <>
      <ShareDirectionsToMobileModal
        isOpen={isShareDirectionsToPhoneModalOpen}
        onClose={() => setIsShareDirectionsToPhoneModalOpen(false)}
      />
      <div
        className={`${styles.headerWrapper} ${
          kiosk && kioskMode && styles[kiosk.model]
        }`}
      >
        <div className={styles.title}>
          {onClose && (
            <ButtonStyled
              kioskSmall={kiosk?.model === KioskType.CTS_DIGITAL_SIGNAGE}
              onClick={onClose}
              variant={
                kiosk?.model === KioskType.CTS_DIGITAL_SIGNAGE
                  ? 'outlined'
                  : 'contained'
              }
              uppercase
            >
              <Icon icon={IconType.LEFT} size={32} />
              {backButtonLabel}
            </ButtonStyled>
          )}
          <div>{t('campusNavigation.directions.directionsTo')}</div>
          <div className={styles.subHeaderWrapper}>
            <Icon
              icon={IconType.LOCATION_OPEN}
              size={kiosk?.model === KioskType.BA_TABLET ? 32 : 24}
              color={'#454E58'}
            />
            <div className={styles.instruction}>{destination}</div>
          </div>
        </div>
        <ButtonStyled
          kioskSmall={kiosk?.model === KioskType.CTS_DIGITAL_SIGNAGE}
          className={styles.shareButton}
          onClick={() => setIsShareDirectionsToPhoneModalOpen(true)}
          variant={'outlined'}
          uppercase
        >
          {t('campusNavigation.directions.SendToPhone')}
        </ButtonStyled>
      </div>
    </>
  );
};
